import { accents } from '@/shared/helpers/accents';

export const removeAccent = (input: string = ''): string => {
  let returnVal = `${input}`;

  Object.keys(accents).forEach((k) => {
    returnVal = returnVal.replace(new RegExp(k, 'g'), accents[k]);
  });

  return returnVal;
};

export const formatToUrl = (input: string = '', allowUnderscore: boolean = false): string => {
  let returnVal: string = `${input}`.trim();

  returnVal = removeAccent(returnVal);
  returnVal = returnVal.replace(/( ){0,1}&( ){0,1}/g, '-and-');
  returnVal = returnVal.replace(/\//g, '-');
  returnVal = returnVal.replace(/[^\w\d_ -]/siug, '').trim();
  returnVal = returnVal.replace(/ /g, '-');
  returnVal = (allowUnderscore) ? returnVal : returnVal.replace(/_/g, '-');
  returnVal = returnVal.replace(/{([-])\1+}/g, '$1');

  return returnVal.toLowerCase();
};

/** Variation of formatToUrl that's a little more permissive and meant for user-defined select options */
export const formatToOptionValue = (input: string = '') => {
  let returnVal: string = `${input}`.trim();

  returnVal = removeAccent(returnVal);
  returnVal = returnVal.replace(/( ){0,1}&( ){0,1}/g, '-and-');
  returnVal = returnVal.replace(/\//g, '-');
  returnVal = returnVal.replace(/[^\w\d_ -.]/siug, '').trim();
  returnVal = returnVal.replace(/ /g, '-');
  returnVal = returnVal.replace(/{([-])\1+}/g, '$1');

  return returnVal.toLowerCase();
};
